import { useState } from "react";
import { useParams } from "react-router-dom";
import AdminHeader from "../../../components/admin/AdminHeader";
import { AdminFooter } from "../../../components/admin/AdminFooter";
import Loading from "react-fullscreen-loading";
import { errorMessageCreate } from "../../../util/custom";
import { showToast, ToastContainer } from "../../../util/toastHelper";
import { CallWithAuth } from "../../../action/apiActions";
import upload_icon from "../../../assets/img/upload_icoon.svg";
import { ADMIN_CMS_IMAGE_UPLOAD_AWS, ADMINTEMPLATE } from "../../../action/apiPath";

const AdminTemplatePageGuideline = () => {
    const [isLoading, setIsLoading] = useState(false);
    const { id } = useParams();

    const handleChangeFile = async (e) => {
        try {
            const { files } = e.target;
            if (files.length > 0) {
                const file = files[0];
                if (file.type != 'application/pdf') {
                    e.target.value = '';
                    showToast("error", "Only pdf is allowed");
                    return;
                }

                const formdata = new FormData();
                formdata.append("file", file);

                setIsLoading(true);
                const response = await CallWithAuth("POST", ADMIN_CMS_IMAGE_UPLOAD_AWS, formdata);
                let message = errorMessageCreate("Something went wrong!");

                if (response?.res?.status === 200 || response?.res?.status === 201) {
                    e.target.value = '';
                    saveGuideline(response?.res?.data?.file_url);
                } else {
                    setIsLoading(false);
                    showToast("error", message);
                }
            }
        } catch (err) {
            setIsLoading(false);
            showToast("error", err);
        }
    }

    const saveGuideline = async (url) => {
        try {
            const response = await CallWithAuth(
                "POST", 
                `${ADMINTEMPLATE}/guideline`,
                {
                    template_id: id,
                    guideline: url
                }
            );

            if (response?.res?.status === 200 || response?.res?.status === 201) {
                showToast("success", "Guideline uploaded successfully.");
            } else {
                let message = errorMessageCreate("Something went wrong!");
                showToast("error", message);
            }

        } catch (error) {
            showToast("error", error)
        }

        setIsLoading(false);
    }

    return (
        <div>
            <AdminHeader />

            {isLoading && (
                <>
                    <Loading
                        loading
                        background="rgba(236, 240, 241, 0.7)"
                        loaderColor="#3498db"
                    />
                </>
            )}

            <div>
                <section className="create_account_block">
                    <div className="site_container">
                        <div className="create_account_form">
                            <div className="heading_block">
                                <span className="tag">Upload Template Guideline</span>
                            </div>
                            <div className="field_block col-md-12">
                                <div className="upload_field">
                                    <div className="upload_ui">
                                        <label className="upload_ui_label">
                                            <input
                                                type="file"
                                                name="audio"
                                                accept=".pdf"  // Only allow pdf file
                                                onChange={handleChangeFile}
                                                style={{ display: "none" }} // Hide input element
                                            />
                                            <div className="ui_inner">
                                                <img src={upload_icon} alt="Upload" />
                                                <h5>Upload</h5>
                                                <p>
                                                    <span>Browse</span> to upload the file
                                                </p>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <ToastContainer />

            <AdminFooter />
        </div>
    )
}

export default AdminTemplatePageGuideline